var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "component",
      style: _vm.getOutStyleDefault(_vm.config.style),
      on: { click: _vm.handleClick, mousedown: _vm.elementMouseDown },
    },
    [
      _vm.componentActiveFlag
        ? _c("edit-bar", {
            attrs: {
              "source-element": _vm.sourceConfig,
              terminal: _vm.terminal,
              element: _vm.config,
              "canvas-id": _vm.canvasId,
              chart: _vm.chart,
              "show-position": _vm.showPosition,
              "series-id-map": _vm.seriesIdMap,
            },
            on: { showViewDetails: _vm.showViewDetails },
          })
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "main_view",
          style: _vm.commonStyle,
          attrs: { id: _vm.componentCanvasId },
        },
        [
          _vm.svgInnerEnable
            ? _c("svg-icon", {
                staticClass: "svg-background",
                style: { color: _vm.config.commonBackground.innerImageColor },
                attrs: { "icon-class": _vm.mainSlotSvgInner },
              })
            : _vm._e(),
          _vm.previewVisible
            ? _c("close-bar", { on: { closePreview: _vm.closePreview } })
            : _vm._e(),
          _vm.config.type === "custom"
            ? _c("de-out-widget", {
                ref: "deOutWidget",
                staticClass: "component-custom",
                staticStyle: { overflow: "hidden" },
                style: _vm.getComponentStyleDefault(_vm.config.style),
                attrs: {
                  id: "component" + _vm.config.id,
                  "out-style": _vm.config.style,
                  "is-relation": _vm.isRelation,
                  element: _vm.config,
                  "in-screen": _vm.inScreen,
                  "edit-mode": "preview",
                  h: _vm.config.style.height,
                  "search-count": _vm.searchCount,
                  "canvas-id": _vm.canvasId,
                },
              })
            : _c(_vm.config.component, {
                ref: "wrapperChild",
                tag: "component",
                staticClass: "component",
                style: _vm.getComponentStyleDefault(_vm.config.style),
                attrs: {
                  "canvas-id": _vm.canvasId,
                  "out-style": _vm.config.style,
                  "prop-value": _vm.config.propValue,
                  "is-edit": false,
                  "in-screen": _vm.inScreen,
                  active: _vm.componentActiveFlag,
                  element: _vm.config,
                  "search-count": _vm.searchCount,
                  h: _vm.config.style.height,
                  "edit-mode": "preview",
                  filters: _vm.filters,
                  terminal: _vm.terminal,
                  "screen-shot": _vm.screenShot,
                  "canvas-style-data": _vm.canvasStyleData,
                  "show-position": _vm.showPosition,
                },
                on: { "fill-chart-2-parent": _vm.setChartData },
              }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }